import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { trackEvent } from '../utils/tracking';
import './AppStoreBadges.css';

export const APP_STORE_URL = 'https://apps.apple.com/us/app/faye-travel-insurance/id1597658672';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.withfaye.app&hl=en_US';

export default function AppStoreBadges({ qrSize = 96 }) {
  return (
    <div className="tp-app-badges">
      <div className="tp-app-badges__store">
        <QRCodeSVG value={APP_STORE_URL} size={qrSize} fgColor="#1A1919" />
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent('App Store Link Clicked', { platform: 'ios' })}
        >
          <img src="/assets/images/app-store-badge.svg" alt="Download on the App Store" className="tp-app-badges__badge" />
        </a>
      </div>
      <div className="tp-app-badges__store">
        <QRCodeSVG value={GOOGLE_PLAY_URL} size={qrSize} fgColor="#1A1919" />
        <a
          href={GOOGLE_PLAY_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent('App Store Link Clicked', { platform: 'android' })}
        >
          <img src="/assets/images/google-play-badge.png" alt="Get it on Google Play" className="tp-app-badges__badge" />
        </a>
      </div>
    </div>
  );
}
